
import Parsley from 'parsleyjs';
  Parsley.on('field:error', function() {
    if (this.$element[0].offsetParent === null) {
      this.$element.parents('.collapse').find('.collapse__state:not(:checked)').prop('checked', true);
    }
  });
